import { Badge, BADGE_COLORS } from "./Badge";
import { cn } from "@/lib/utils";

/**
 * Chip-style color picker — renders every available badge color as a
 * labeled, tinted button so the user can see the actual badge they'll
 * end up with. Selection is shown via a ring around the chip.
 *
 * Used by tag-edit + smart-list-edit dialogs (and any future "name +
 * color" forms). For dense inline UIs that just need a swatch (kanban
 * stage colors, calendar colors), use `ColorSwatchPicker` instead.
 */
export function BadgeColorPicker({
  value, onChange, className,
}: {
  value: string;
  onChange: (c: string) => void;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {BADGE_COLORS.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          aria-pressed={value === c}
          aria-label={`Color: ${c}`}
          className={cn(
            "rounded-md transition",
            value === c ? "ring-2 ring-zinc-400" : "ring-0 hover:opacity-80",
          )}
        >
          <Badge color={c}>{c}</Badge>
        </button>
      ))}
    </div>
  );
}
